import {isServer} from '@adv-mt/mt-utils'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserMappersFactory from '../Mappers/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import {UserRequestsFactory} from '../Requests/factory.js'
import {AdShareByEmailUserService} from './AdShareByEmailUserService.js'
import {CheckPhoneVerificationStatusUserService} from './CheckPhoneVerificationStatusUserService.js'
import {GetContactTokenUserService} from './GetContactTokenUserService.js'
import GetCurrentUserService from './GetCurrentUserService.js'
import {GetPhoneVerificationCodeUserService} from './GetPhoneVerificationCodeUserService.js'
import GetUserByIdUserService from './GetUserByIdUserService.js'
import {GetUserService} from './GetUserService.js'
import GetUserTakeoutLinkService from './GetUserTakeoutLinkService.js'
import GetUserTakeoutListService from './GetUserTakeoutListService.js'
import {SaveAdShareByEmailHitUserService} from './SaveAdShareByEmailHitUserService.js'
import {SaveContactTokenUserService} from './SaveContactTokenUserService.js'
import {SaveLeadHitUserService} from './SaveLeadHitUserService.js'
import {UpdateCurrentUserService} from './UpdateCurrentUserService.js'
import {ValidatePhoneVerificationCodeUserService} from './ValidatePhoneVerificationCodeUserService.js'

export default class UserServicesFactory {
  static checkPhoneVerificationStatusUserService = ({config}) =>
    new CheckPhoneVerificationStatusUserService({
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static getPhoneVerificationCodeUserService = ({config}) =>
    new GetPhoneVerificationCodeUserService({
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static getContactTokenUserService = ({config}) =>
    new GetContactTokenUserService({
      getContactTokenUserErrorFactory: UserErrorsFactory.getContactTokenUserError,
      userRepository: isServer
        ? UserRepositoriesFactory.emptyUserRepository()
        : UserRepositoriesFactory.sessionStorageUserRepository({config})
    })

  static getCurrentUserService = ({config}) =>
    new GetCurrentUserService({
      repository: UserRepositoriesFactory.cookieUserRepository({
        config
      })
    })

  static updateCurrentUserService = ({config}) =>
    new UpdateCurrentUserService({
      cookieUserRepository: UserRepositoriesFactory.cookieUserRepository({
        config
      })
    })

  static getUserService = ({config}) =>
    new GetUserService({
      repository: UserRepositoriesFactory.httpUserRepository({
        config
      })
    })

  static getUserTakeoutListService = ({config}) =>
    new GetUserTakeoutListService({
      repository: UserRepositoriesFactory.httpUserRepository({
        config
      }),
      service: UserServicesFactory.getCurrentUserService({config})
    })

  static getUserTakeoutLinkService = ({config}) =>
    new GetUserTakeoutLinkService({
      repository: UserRepositoriesFactory.httpUserRepository({
        config
      }),
      service: UserServicesFactory.getCurrentUserService({config})
    })

  static saveContactTokenUserService = ({config}) =>
    new SaveContactTokenUserService({
      saveContactTokenUserErrorFactory: UserErrorsFactory.saveContactTokenUserError,
      userRepository: isServer
        ? UserRepositoriesFactory.emptyUserRepository()
        : UserRepositoriesFactory.sessionStorageUserRepository({config})
    })

  static saveLeadHitUserService = ({config}) =>
    new SaveLeadHitUserService({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      fromLeadHitUserVOToLeadHitUserRequestMapper: UserMappersFactory.fromLeadHitUserVOToLeadHitUserRequestMapper({
        config
      })
    })

  static saveAdShareByEmailHitUserService = ({config}) =>
    new SaveAdShareByEmailHitUserService({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static adShareByEmailUserService = ({config}) =>
    new AdShareByEmailUserService({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static getUserByIdUserService = ({config}) =>
    new GetUserByIdUserService({
      updateCurrentUserService: UserServicesFactory.updateCurrentUserService({
        config
      }),
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static validatePhoneVerificationCodeUserService = ({config}) =>
    new ValidatePhoneVerificationCodeUserService({
      updateCurrentUserRequestFactory: UserRequestsFactory.updateCurrentUserRequest,
      updateCurrentUserService: UserServicesFactory.updateCurrentUserService({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })
}
